export default [
  {
    path: '/growup-record/:id/:companyId/:campusId',
    name: 'growup-record',
    component: () => import('@simple/views/share/growup-record.vue'),
  },
  {
    path: '/evaluation-detail/:id/:companyId/:campusId',
    name: 'evaluation-detail',
    component: () => import('@simple/views/share/evaluation-detail.vue'),
  },
  {
    path: '/comment-detail/:commentId/:companyId/:campusId',
    name: 'comment-detail',
    component: () => import('@simple/views/share/comment-detail.vue'),
  },{
    path: '/cepingDetail/:id/:companyId/:campusId',
    name: 'cepingDetail',
    component: () => import('@simple/views/share/ceping-detail.vue'),
  },
  {
    path: '/file-download',
    name: 'fileDownload',
    component: () => import('@simple/views/share/file-download.vue'),
  },
];
